export default function Search({
  value,
  onChangeHandler,
  placeHolder = "Search athletes / teams",
  classNames = "",
}) {
  return (
    <input
      id="athlete_search"
      name="athlete_search"
      autoComplete="off"
      className={` nav-search athletes-search ${classNames}`}
      value={value}
      onChange={onChangeHandler}
      placeholder={placeHolder}
      type="text"
    />
  );
}
